<template>
    <el-container>
        <el-form class="previewFormWith" ref="dynamicPreviewForm">
            <slot name="header"></slot>
            <td-dynamic ref="tdDynamic" labelWidth="120px" :groupFlg="groupFlg" v-model="groupElementValue"> </td-dynamic>
            <slot></slot>
            <el-col span="24">
                <el-main style="margin-top:20px">
                    <td-table
                        v-show="uploadFileTabShow && uploadFileTable"
                        :columns="columns"
                        ref="uploadFileTab"
                        :hasPage="false"
                        :hasMutiSelect="false"
                        :dataSource="tableData"
                        :total="total"
                        :rowKey="rowKey"
                        :height="200"
                    ></td-table>
                    <slot name="table"></slot>
                </el-main>
            </el-col>
            <slot name="footer"></slot>
        </el-form>
    </el-container>
</template>
<script>
// slot插槽待优化为扩展组中的插槽
import api from './../assets/api.js';
export default {
    props: {
        //流程定义Id
        processDefintionId: {
            type: String,
            default: function() {
                return '';
            }
        },
        //任务环节Id
        taskLinkId: {
            type: String,
            default: function() {
                return '';
            }
        },
        //流程编号
        processNumber: {
            type: String,
            default: function() {
                return '-1';
            }
        },
        taskId: {
            type: String,
            default: function() {
                return '';
            }
        },
        /* 显示名称宽度设置 */
        labelWidth: {
            type: String,
            default: function() {
                return '120px';
            }
        },
        parentFunc: {
            type: Function,
            default: null
        },
        failFunc: {
            type: Function,
            default: null
        },
        // 不创建业务表外部接入数据时，赋值自定义表单传参字段 // 外部接入数据时不支持上传和文件列表形式
        groupElement: {},
        uploadFileTable: {
            type: Boolean,
            default: true
        },
        uploadFileOprea: {
            type: Boolean,
            default: true
        },
        delFileFlg: {
            type: Boolean,
            default: true
        },
        version: {
            type: String,
            default: function() {
                return '';
            }
        }
    },
    watch: {
        /* 监听数据的变化，实时生效 */
        groupElement: {
            handler: function(newVal) {
                this.groupElement = newVal;
                if (this.groupElement == {}) {
                    this.getGroupElementValue();
                } else {
                    for (let key in this.groupElement) {
                        let str = this.groupElement[key];
                        if (str != '' && str != null) {
                            if (!typeof str === 'number' || isNaN(str)) {
                                if (typeof str == 'string') {
                                    if (str.substring(0, 1) == '[' && str.charAt(str.length - 1) == ']') {
                                        this.groupElement[key] = JSON.parse(str);
                                    }
                                }
                            }
                        }
                    }
                    this.groupElementValue = this.groupElement;
                }
            },
            deep: true
        }
    },
    watch: {
        /* 监听数据的变化，实时生效 */
        groupElement: {
            handler: function(newVal) {
                this.groupElement = newVal;
                if (this.groupElement == {}) {
                    this.getGroupElementValue();
                } else {
                    for (let key in this.groupElement) {
                        let str = this.groupElement[key];
                        if (str != '' && str != null) {
                            if (!typeof str === 'number' || isNaN(str)) {
                                if (typeof str == 'string') {
                                    if (str.substring(0, 1) == '[' && str.charAt(str.length - 1) == ']') {
                                        this.groupElement[key] = JSON.parse(this.groupElement[key]);
                                    }
                                }
                            }
                        }
                    }
                    this.groupElementValue = this.groupElement;
                }
            },
            deep: true
        }
    },
    created() {
        if (this.version) {
            this.groupFlg = this.processDefintionId + ':' + this.version + ':' + this.taskLinkId;
        } else {
            api.getActiveTemplateIdByKey({ templateKey: this.processDefintionId }, response => {
                if (response.data.content) {
                    let strs = response.data.content.split(':');
                    this.version = strs[1];
                    this.groupFlg = this.processDefintionId + ':' + this.version + ':' + this.taskLinkId;
                    if (!this.version) {
                        this.groupFlg = this.processDefintionId + ':TEMP:' + this.taskLinkId;
                    }
                    // 文件列表初始化
                    api.listProcessElementInfo(JSON.stringify({ currentPage: 1, isPage: true, pageNum: 1, pageSize: 999, sId: this.processDefintionId + ':' + this.version + ':' }), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                            this.$log.error('/extendManage/listProcessElementInfo', response.data.statusMessage);
                            return;
                        }
                        if (response.data.content.length > 0) {
                            for (let index in response.data.content) {
                                if (response.data.content[index].sElementType && response.data.content[index].sElementType == 'TdUploadX') {
                                    this.allUploadKeys.push(response.data.content[index].sElementFlg);
                                    this.allUploadNames.push(response.data.content[index].sName);
                                }
                            }
                        }
                        if (this.allUploadKeys.length > 0) {
                            api.listGroupElementInfo({ sGroupId: this.groupFlg }, res => {
                                if (res.data.content.length > 0) {
                                    for (let index in res.data.content) {
                                        if (res.data.content[index].sElementFlg && this.allUploadKeys.indexOf(res.data.content[index].sElementFlg) > -1) {
                                            if (this.uploadFileOprea) {
                                                this.uploadKeys.push(res.data.content[index].sElementFlg);
                                            }
                                        }
                                    }
                                }
                                let params = {
                                    tableName: 'PROCESS_' + this.processDefintionId,
                                    sid: this.processNumber
                                };
                                api.selfBuildTableSelect(JSON.stringify(params), response => {
                                    if (response.data.content && response.data.content.length > 0) {
                                        let groupElementValues = response.data.content[0];
                                        for (let item in groupElementValues) {
                                            if (this.allUploadKeys.indexOf(item) > -1 && groupElementValues[item]) {
                                                let fileJsonArr = JSON.parse(groupElementValues[item]);
                                                for (let num in fileJsonArr) {
                                                    this.tableData.push(fileJsonArr[num]);
                                                    this.uploadFileTabShow = true;
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        }
                    });
                } else {
                    this.groupFlg = this.processDefintionId + ':TEMP:' + this.taskLinkId;
                }
            });
        }
        if (this.groupElement == {}) {
            this.getGroupElementValue();
        } else {
            for (let key in this.groupElement) {
                let str = this.groupElement[key];
                if (str != '' && str != null) {
                    if (!typeof str === 'number' || isNaN(str)) {
                        if (typeof str == 'string') {
                            if (str.substring(0, 1) == '[' && str.charAt(str.length - 1) == ']') {
                                this.groupElement[key] = JSON.parse(this.groupElement[key]);
                            }
                        }
                    }
                }
            }
            this.groupElementValue = this.groupElement;
        }
    },
    // 定义变量
    data() {
        return {
            allUploadKeys: [],
            allUploadNames: [],
            uploadKeys: [],
            // 文件列表数组
            tableData: [],
            // 文件列表显示开关
            uploadFileTabShow: false,
            rowKey: 'key',
            total: 0, // 总条数
            groupElementValue: {},
            groupFlg: '',
            columns: [
                {
                    prop: 'key',
                    align: 'left',
                    label: this.$t('pgCommon.FILE_KEY'),
                    showColumn: false
                },
                {
                    prop: 'fileType',
                    align: 'left',
                    label: this.$t('pgCommon.FILE_TYPE'),
                    showColumn: true
                },
                {
                    prop: 'fileTypeKey',
                    align: 'left',
                    label: this.$t('pgCommon.FILE_TYPE_KEY'),
                    showColumn: false
                },
                {
                    prop: 'fileName',
                    align: 'left',
                    label: this.$t('pgCommon.FILE_NAME'),
                    showColumn: true
                },
                {
                    prop: 'serviceId',
                    align: 'left',
                    label: this.$t('pgCommon.FILE_SERVICE_ID'),
                    showColumn: false
                },
                {
                    prop: '',
                    align: 'center',
                    label: this.$t('pgCommon.OPERATE'),
                    showColumn: true,
                    render: (createElement, params) => {
                        if (this.uploadKeys.includes(params.row.fileTypeKey) && this.delFileFlg) {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.downloadFile(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.DOWNLOAD')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.deleteFile(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.DELETE')
                                )
                            ]);
                        } else {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.downloadFile(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.DOWNLOAD')
                                )
                            ]);
                        }
                    }
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        // 设置样式
        /*
            keyName: 组件关键字
            style:组件样式
        */
        setStyle(keyName, style) {
            this.$refs.tdDynamic.setStyle(keyName, style);
        },
        // 设置组件的属性
        /*
            propName: 组件属性
            value:属性值
            例：propName = disabled
                value = true
        */
        setProps(keyName, propName, value) {
            this.$refs.tdDynamic.setProps(keyName, propName, value);
        },
        getFileData() {
            return this.tableData;
        },
        // 刷新上传表格
        refreshUploadGrid() {
            if (this.tableData.length > 0) {
                this.uploadFileTabShow = true;
            } else {
                this.uploadFileTabShow = false;
            }
        },
        // 永久存储
        myBaseUpload(content) {
            let para = new FormData();
            let multipartFile = content[0].file;
            para.append('multipartFile', multipartFile);
            para.append('serviceId', content[0].data.serviceId);
            para.append('storageFlag', 'baseSpaceFlag');
            api.upload(para, response => {
                if (response.data.content) {
                    if (this.allUploadKeys.indexOf(content[0].data.ref) > -1) {
                        let index = this.allUploadKeys.indexOf(content[0].data.ref);
                        let fileTableJson = {
                            key: response.data.content.key,
                            fileType: this.allUploadNames[index],
                            fileTypeKey: content[0].data.ref,
                            fileName: response.data.content.fileName + response.data.content.fileType,
                            serviceId: content[0].data.serviceId
                        };
                        this.tableData.push(fileTableJson);
                        this.$refs.tdDynamic.getfromInfo()[fileTableJson.fileTypeKey] = fileTableJson;
                    }
                }
                this.validateForm();
                this.refreshUploadGrid();
                this.$refs.tdDynamic.$refs[content[0].data.ref].clearFiles();
            });
        },
        // 非永久存储
        myCommonUpload(content) {
            let para = new FormData();
            let multipartFile = content[0].file;
            para.append('multipartFile', multipartFile);
            para.append('serviceId', content[0].data.serviceId);
            para.append('storageFlag', 'commonSpaceFlag');
            api.upload(para, response => {
                if (response.data.content) {
                    if (this.allUploadKeys.indexOf(content[0].data.ref) > -1) {
                        let index = this.allUploadKeys.indexOf(content[0].data.ref);
                        let fileTableJson = {
                            key: response.data.content.key,
                            fileType: this.allUploadNames[index],
                            fileTypeKey: content[0].data.ref,
                            fileName: response.data.content.fileName + response.data.content.fileType,
                            serviceId: content[0].data.serviceId
                        };
                        this.tableData.push(fileTableJson);
                        this.$refs.tdDynamic.getfromInfo()[fileTableJson.fileTypeKey] = fileTableJson;
                    }
                }
                this.validateForm();
                this.refreshUploadGrid();
                this.$refs.tdDynamic.$refs[content[0].data.ref].clearFiles();
            });
        },
        // 下载文件
        downloadFile(row) {
            let serviceId = row.serviceId;
            let para = {
                id: serviceId
            };
            api.queryConfigInfos(para, response => {
                if (response.data.statusCode == 'API-COMMON-INF-OK' && response.data.content && response.data.content[0].fileServerIP) {
                    console.log(response.data.content);
                    let fileName = row.fileName;
                    let arr = row.fileName.split('.');
                    var last = arr[arr.length - 1];
                    fileName = fileName.substr(0, row.fileName.length - last.length - 1);
                    window.location.href =
                        window.location.protocol +
                        '//' +
                        window.location.host +
                        '//' +
                        response.data.content[0].fileServerIP +
                        ':9016/FileServer/storageSpace/download?key=' +
                        row.key +
                        '&fileName=' +
                        encodeURI(fileName);
                    // window.open(window.location.hostname + ':9016/FileServer/storageSpace/download?key=' + row.key + '&fileName=' + fileName);
                }
            });
        },
        // 删除文件
        deleteFile(row) {
            this.$confirm(this.$t('pgCommon.WHETHER_DELETE'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    for (let index in this.tableData) {
                        if (this.tableData[index].key == row.key) {
                            let para = {
                                keys: [row.key],
                                serviceId: row.serviceId
                            };
                            api.deleteFile(para, response => {
                                if (response.data.statusCode == window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.tableData.splice(index, 1);
                                    this.refreshUploadGrid();
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                                } else {
                                    this.$message({ showClose: true, message: this.$t('pgCommon.OPERATION_FAIL'), type: 'error' });
                                    return;
                                }
                            });
                        }
                    }
                })
                .catch(() => {});
        },
        deleteProcess() {
            let param = {
                proInsId: this.processNumber
            };
            api.deleteProIns(param, response => {
                this.operEdit = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                    this.loading = false;
                    return;
                }
                return response.data.count;
            });
        },
        getGroupElementValue() {
            let params = {
                tableName: 'PROCESS_' + this.processDefintionId,
                sid: this.processNumber
            };
            api.selfBuildTableSelect(JSON.stringify(params), response => {
                let groupElementValues = response.data.content[0];
                for (let key in groupElementValues) {
                    let str = groupElementValues[key];
                    if (str != '' && str != null) {
                        if (!typeof str === 'number' || isNaN(str)) {
                            if (typeof str == 'string') {
                                if (str.substring(0, 1) == '[' && str.charAt(str.length - 1) == ']') {
                                    // groupElementValues[key] = str
                                    //     .replace('[', '')
                                    //     .replace(']', '')
                                    //     .replace(/\"/g, '')
                                    //     .split(',');
                                    groupElementValues[key] = JSON.parse(groupElementValues[key]);
                                }
                            }
                        }
                    }
                }
                this.groupElementValue = groupElementValues;
            });
        },
        getFormInfo() {
            return this.$refs.tdDynamic.getfromInfo();
        },
        validateForm() {
            let validateForm = false;
            this.$refs.tdDynamic.$refs.dynamicForm.validate(valid => {
                if (valid) {
                    validateForm = true;
                } else {
                    validateForm = false;
                }
            });
            return validateForm;
        },
        // validateAuth(){},
        // 提交表单和流程方法
        // 按钮范围，扩展字段json键值对，提示信息，是否启用权限校验
        submitFormAuth(paramsRange, selefString, tipMessage, validateAuth) {
            this.formInfo = this.$refs.tdDynamic.getfromInfo();
            // 遍历json表单对象
            for (var key in this.formInfo) {
                if (key == 'nextUsers_downLeavel') {
                    // 用户下级权限
                    this.formInfo[key] = true;
                }
                if (key == 'nextUsers_upLeavel') {
                    // 用户上级权限
                    this.formInfo[key] = true;
                }
                if (key == 'nextGroups_handle') {
                    // 组织手动权限
                    let depts = [];
                    if (this.formInfo[key] != undefined && null != this.formInfo[key]) {
                        for (let index in this.formInfo[key]) {
                            depts.push(this.formInfo[key][index].orgId);
                        }
                    }
                    this.formInfo[key] = depts;
                }
                if (key == 'nextGroups_downLeavel') {
                    // 组织下级权限
                    this.formInfo[key] = true;
                }
                if (key == 'nextGroups_upLeavel') {
                    // 组织上级权限
                    this.formInfo[key] = true;
                }
                if (key == 'showUsers_downLeavel') {
                    // 抄送下级权限
                    this.formInfo[key] = true;
                }
                if (key == 'showUsers_upLeavel') {
                    // 抄送上级权限
                    this.formInfo[key] = true;
                }
            }
            let extendValue = {};
            let fromWhos = [];
            //拼串
            if (selefString == '' || selefString == {}) {
                extendValue = this.formInfo;
            } else {
                extendValue = this.formInfo;
                for (let key in selefString) {
                    extendValue[key] = selefString[key];
                }
            }
            if (extendValue['fromWhos'] != undefined) {
                fromWhos = extendValue['fromWhos'];
                extendValue['fromWhos'] = undefined;
            }
            // 重载文件列表
            for (let index in this.allUploadKeys) {
                this.$refs.tdDynamic.getfromInfo()[this.allUploadKeys[index]] = [];
            }
            // 将文件列表保存到后台
            for (let index in this.tableData) {
                let fileTypeKey = this.tableData[index].fileTypeKey;
                if (this.allUploadKeys.includes(fileTypeKey)) {
                    this.$refs.tdDynamic.getfromInfo()[fileTypeKey].push(this.tableData[index]);
                }
            }
            let params = {
                taskId: this.taskId,
                paramsRange: paramsRange,
                processNumber: this.processNumber,
                currPerson: sessionStorage.userId,
                S_FROM_KEY: this.taskLinkId,
                S_PRO_KEY: this.processDefintionId,
                tableName: 'PROCESS_' + this.processDefintionId,
                fromWhos: fromWhos,
                extendValue: extendValue
            };
            this.$refs.tdDynamic.$refs.dynamicForm.validate(valid => {
                if (valid) {
                    if (validateAuth) {
                        api.getNextTaskUsersOrGroups(JSON.stringify(params), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('templateManage/getNextTaskUsersOrGroups', response.data.statusMessage);
                                this.failFunc(response.data);
                                return;
                            }
                            api.savePrviewData(params, response => {
                                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('templateManage/savePrviewData', response.data.statusMessage);
                                    this.failFunc(response.data);
                                    return;
                                }
                                if (tipMessage) {
                                    this.tableData = [];
                                    this.refreshUploadGrid();
                                    this.$message({ showClose: true, message: tipMessage, type: 'success' });
                                }
                                this.parentFunc(response.data.content);
                            });
                        });
                    } else {
                        api.savePrviewData(JSON.stringify(params), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('templateManage/savePrviewData', response.data.statusMessage);
                                this.failFunc(response.data);
                                return;
                            }
                            if (tipMessage) {
                                this.tableData = [];
                                this.refreshUploadGrid();
                                this.$message({ showClose: true, message: tipMessage, type: 'success' });
                            }
                            this.parentFunc(response.data.content);
                        });
                    }
                }
            });
        },
        submitForm(paramsRange, selefString, tipMessage, callback, clickBtnId) {
            this.formInfo = this.$refs.tdDynamic.getfromInfo();
            for (var key in this.formInfo) {
                if (key == 'nextUsers_downLeavel') {
                    // 用户下级权限
                    this.formInfo[key] = true;
                }
                if (key == 'nextUsers_upLeavel') {
                    // 用户上级权限
                    this.formInfo[key] = true;
                }
                if (key == 'nextGroups_handle') {
                    // 组织手动权限
                    let depts = [];
                    if (this.formInfo[key] != undefined && null != this.formInfo[key]) {
                        for (let index in this.formInfo[key]) {
                            depts.push(this.formInfo[key][index].orgId);
                        }
                    }
                    this.formInfo[key] = depts;
                }
                if (key == 'nextGroups_downLeavel') {
                    // 组织下级权限
                    this.formInfo[key] = true;
                }
                if (key == 'nextGroups_upLeavel') {
                    // 组织上级权限
                    this.formInfo[key] = true;
                }
                if (key == 'showUsers_downLeavel') {
                    // 抄送下级权限
                    this.formInfo[key] = true;
                }
                if (key == 'showUsers_upLeavel') {
                    // 抄送上级权限
                    this.formInfo[key] = true;
                }
            }
            let extendValue = {};
            let fromWhos = [];
            //拼串
            if (selefString == '' || selefString == {}) {
                extendValue = this.formInfo;
            } else {
                extendValue = this.formInfo;
                for (let key in selefString) {
                    extendValue[key] = selefString[key];
                }
            }
            if (extendValue['fromWhos'] != undefined) {
                fromWhos = extendValue['fromWhos'];
                extendValue['fromWhos'] = undefined;
            }
            // 重载文件列表
            for (let index in this.allUploadKeys) {
                this.$refs.tdDynamic.getfromInfo()[this.allUploadKeys[index]] = [];
            }
            // 将文件列表保存到后台
            for (let index in this.tableData) {
                let fileTypeKey = this.tableData[index].fileTypeKey;
                if (this.allUploadKeys.includes(fileTypeKey)) {
                    this.$refs.tdDynamic.getfromInfo()[fileTypeKey].push(this.tableData[index]);
                }
            }
            let clickButtonName = tipMessage.substring(0, tipMessage.lastIndexOf(this.$t('workFlowProcessAudit.SUCCESS')));
            let params = {
                taskId: this.taskId,
                paramsRange: paramsRange,
                processNumber: this.processNumber,
                currPerson: sessionStorage.userId,
                S_FROM_KEY: this.taskLinkId,
                S_PRO_KEY: this.processDefintionId,
                tableName: 'PROCESS_' + this.processDefintionId,
                fromWhos: fromWhos,
                extendValue: extendValue,
                clickButtonId: clickBtnId,
                clickButtonName: clickButtonName
            };
            this.$refs.tdDynamic.$refs.dynamicForm.validate(valid => {
                if (valid) {
                    api.savePrviewData(JSON.stringify(params), response => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('templateManage/savePrviewData', response.data.statusMessage);
                            this.failFunc(response.data);
                            return;
                        }
                        if (tipMessage) {
                            this.tableData = [];
                            this.refreshUploadGrid();
                            this.$message({ showClose: true, message: tipMessage, type: 'success' });
                        }
                        this.parentFunc(response.data.content);
                    });
                }
                callback(valid);
                // else {
                //     this.failFunc();
                // }
            });
        }
    }
};
</script>
<style scoped>
.previewFormWith {
    width: 100%;
}
.previewFormWith >>> .el-upload--picture-card {
    width: 146px !important;
    height: 146px !important;
    background-color: rgb(0, 0, 0, 0);
}
</style>
